"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchParamKeys = exports.UIConfig = exports.MapConfig = void 0;
exports.MapConfig = {
    'WebmapId': 'ba6c28836375471d8d6233d521f5ef26',
    'WildfiresLayerUrl': 'https://services9.arcgis.com/RHVPKKiFTONKtxq3/arcgis/rest/services/USA_Wildfires_v1/FeatureServer/0',
    'WildfireLayerClassificationField': 'DailyAcres',
    'SmokeLayerUrl': 'https://utility.arcgis.com/usrsvcs/servers/1bb73533826544d1a2c47475c2ae5aee/rest/services/LiveFeeds/NDGD_SmokeForecast/MapServer'
};
exports.UIConfig = {
    'SidebarWidth': 450,
    'ThemeColorDarkPurple': 'rgba(26,0,17,.8)',
    'ThemeColorBrightPurple': 'rgba(103, 0, 67, 0.5)',
    'ThemeColorBrightPurpleOpaque': 'rgba(103, 0, 67, 1)',
    'ThemeColorYellow': 'rgb(209, 136, 2)'
};
exports.SearchParamKeys = {
    'mapCenterLocation': '@'
};
